{
  "schemaVersion": 1,
  "approved": true,
  "mood": "inspired",
  "posts": [
    {
      "id": "feeling-inspired-01",
      "title": "One generous idea",
      "text": "Choose one thing you would make larger. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "small-room", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-001.webp",
      "alt": "AI-generated interior illustration: A small chalk-white living room with a rust linen sofa, oak oval table and oversized burgundy abstract art. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "circle",
        "prompt": "Choose one thing you would make larger."
      },
      "visualMetadata": {
        "tags": ["inspired", "small-room", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-02",
      "title": "An invitation on a blank wall",
      "text": "Imagine a colour beyond the edge of the frame. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "rental-home", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-002.webp",
      "alt": "AI-generated interior illustration: An inviting rented sitting room with oatmeal walls, olive curtains, tobacco cushions and portable ceramic lamps. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "arcs",
        "prompt": "Imagine a colour beyond the edge of the frame."
      },
      "visualMetadata": {
        "tags": ["inspired", "rental-home", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-03",
      "title": "Three pools of possibility",
      "text": "Notice what each pool of light makes visible. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "lighting", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-003.webp",
      "alt": "AI-generated interior illustration: An indigo evening living room with three distinct warm light sources, a reading chair and a textured plaster wall. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "orbit",
        "prompt": "Notice what each pool of light makes visible."
      },
      "visualMetadata": {
        "tags": ["inspired", "lighting", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-04",
      "title": "A shelf with room for the next thought",
      "text": "Find a gap and imagine what could belong there. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "bookshelves", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-004.webp",
      "alt": "AI-generated interior illustration: A walnut bookshelf with thoughtfully spaced books, blue ceramic bowls and an inviting reading chair in soft daylight. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "circle",
        "prompt": "Find a gap and imagine what could belong there."
      },
      "visualMetadata": {
        "tags": ["inspired", "bookshelves", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-05",
      "title": "Texture before colour",
      "text": "Name three textures you would like to touch. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "bedroom", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-005.webp",
      "alt": "AI-generated interior illustration: A softly lit bedroom layered with oat cotton, clay linen, a textured cream throw and warm timber bedside furniture. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "arcs",
        "prompt": "Name three textures you would like to touch."
      },
      "visualMetadata": {
        "tags": ["inspired", "bedroom", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-06",
      "title": "A good place to begin",
      "text": "Imagine the first small change that would welcome you home. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "hallway", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-006.webp",
      "alt": "AI-generated interior illustration: A slender sage hallway with a shallow dark timber landing shelf, ceramic key bowl, oval mirror and clear passage. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "orbit",
        "prompt": "Imagine the first small change that would welcome you home."
      },
      "visualMetadata": {
        "tags": ["inspired", "hallway", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-07",
      "title": "Let the picture lead",
      "text": "Choose one colour and imagine its next appearance. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "art-at-home", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-007.webp",
      "alt": "AI-generated interior illustration: A terracotta reading corner with a well-composed asymmetrical group of framed abstract artworks above a blue chair. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "circle",
        "prompt": "Choose one colour and imagine its next appearance."
      },
      "visualMetadata": {
        "tags": ["inspired", "art-at-home", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-08",
      "title": "A room with two stories",
      "text": "Picture this room at two different times of day. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "living-room", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-008.webp",
      "alt": "AI-generated interior illustration: A light-filled living room with a stone linen sofa facing conversation space and one olive chair turned towards a leafy window. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "arcs",
        "prompt": "Picture this room at two different times of day."
      },
      "visualMetadata": {
        "tags": ["inspired", "living-room", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-09",
      "title": "What deserves a place in view?",
      "text": "Choose one everyday object worth displaying. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "kitchen", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-009.webp",
      "alt": "AI-generated interior illustration: A compact cream kitchen with one oak shelf holding white bowls, dark glazed mugs and clear glasses above a clean worktop. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "orbit",
        "prompt": "Choose one everyday object worth displaying."
      },
      "visualMetadata": {
        "tags": ["inspired", "kitchen", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    },
    {
      "id": "feeling-inspired-10",
      "title": "A corner for the next idea",
      "text": "Imagine the first sentence you would write here. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "inspired",
      "hashtags": ["inspired", "visual-moment", "workspace", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-home-decor-010.webp",
      "alt": "AI-generated interior illustration: A walnut writing desk in a muted rose living room, closed laptop, tidy tray and sculptural cream task lamp at dusk. Not a photograph of a real home.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated interior illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "inspired",
        "shape": "circle",
        "prompt": "Imagine the first sentence you would write here."
      },
      "visualMetadata": {
        "tags": ["inspired", "workspace", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "inspired"
      }
    }
  ]
}
